var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOdometer = function SvgOdometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#odometer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.946 6.705a.979.979 0 1 1-.692-.693l.868-.868a.49.49 0 0 1 .693.692zM7 2.063a.49.49 0 0 1 .49.49v.49a.49.49 0 0 1-.98 0v-.49a.49.49 0 0 1 .49-.49m4.405 5.385a.49.49 0 0 0 0-.98h-.49a.49.49 0 0 0 0 .98zm-9.3-.49a.49.49 0 0 1 .49-.49h.49a.49.49 0 0 1 0 .98h-.49a.49.49 0 0 1-.49-.49m7.933-2.346.346-.346a.49.49 0 0 0-.692-.692l-.346.346a.49.49 0 0 0 .692.692m-5.527 0a.49.49 0 0 0 0-.692l-.346-.346a.49.49 0 0 0-.692.692l.346.346a.49.49 0 0 0 .692 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 .595a6.363 6.363 0 0 0-5.92 8.701.955.955 0 0 0 .893.598h10.055c.377 0 .742-.22.892-.598A6.363 6.363 0 0 0 7 .594M1.616 6.958a5.384 5.384 0 1 1 10.401 1.958H1.983a5.4 5.4 0 0 1-.367-1.958",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.363 7.002a6.363 6.363 0 0 1-12.726 0l.002-.089h.98l-.003.089a5.384 5.384 0 1 0 10.768 0l-.002-.089h.98z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "odometer_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgOdometer;